<template lang="pug">
b-modal#modal-add-admin-user.modal-background(
  size="lg"
  hide-header-close
  no-close-on-backdrop
  hide-footer
  @hidden="resetModal"
)
  .container.add-user-admin
    .loader.text-center.loader-modal(v-if="loading")
      i.fas.fa-spinner.fa-spin.fa-2x
    form#user-form(@submit='onSubmit' novalidate)
      .form-group.form-row
        label.col-sm-4.col-form-label.form-label(for='user-email')
          | {{ $t('user.email') }}
          |  ({{ $t('user.half') }})
          span  *
        .col-sm-8
          input#user-email.form-control(
            :class="{ 'red-bordered': !isEmpty(errors.email) }"
            name='email'
            v-model='user.email'
            type='email'
            required
          )
          .invalid-feedback(v-for='obj in errors.email', role='alert') {{ getError(obj) }}
      .form-group.form-row
        label.col-sm-4.col-form-label.form-label(for='user-last-name')
          | {{ $t('user.last_name') }}
          |  ({{ $t('user.full') }})
          span  *
        .col-sm-8
          input#user-last-name.form-control(
            :class="{ 'red-bordered': !isEmpty(errors.last_name) }"
            name='last_name'
            v-model='user.last_name'
            @keyup='allowJpOnly($event)'
            required
          )
          .invalid-feedback(v-for='obj in errors.last_name', role='alert') {{ getError(obj) }}
      .form-group.form-row
        label.col-sm-4.col-form-label.form-label(for='user-first-name')
          | {{ $t('user.first_name') }}
          |  ({{ $t('user.full') }})
          span  *
        .col-sm-8
          input#user-first-name.form-control(
            :class="{ 'red-bordered': !isEmpty(errors.first_name) }"
            name='first_name'
            v-model='user.first_name'
            @keyup='allowJpOnly($event)'
            required
          )
          .invalid-feedback(v-for='obj in errors.first_name', role='alert') {{ getError(obj) }}
      .form-group.form-row
        label.col-sm-4.col-form-label.form-label(for='user-organization')
          | {{ $t('user.organization') }}
          span  *
        div(v-if="isSuperadmin").col-sm-8
          select#user-organization.form-control.select-wraper(
            :class="{ 'red-bordered': !isEmpty(errors.organization) }"
            v-model='user.organization_id',
            name='organization'
            required
          )
            option(:value='org.id' v-for='org in organizations') {{ org.name }}
          i.fa.fa-chevron-down.icon-action
          .invalid-feedback(v-for='obj in errors.organization', role='alert') {{ getError(obj) }}
        div.col-sm-8(v-else)  
          input.form-control(
            :value="this.currentUser.organization_name"
            disabled
          )
      .form-group.form-row
        label.col-sm-4.col-form-label.form-label(for='user-department')
          | {{ $t('user.department') }}
          | ({{ $t('user.full') }})
          span *
        .col-sm-8
          input#user-department.form-control(
            :class="{ 'red-bordered': !isEmpty(errors.department) }"
            name='department'
            v-model='user.department'
            @keyup='allowJpOnly($event)'
            required
          )
          .invalid-feedback(v-for='obj in errors.department', role='alert') {{ getError(obj) }}
      phones(
        v-if="!phoneDeleted(phone)"
        v-for="(phone, index) in phones"
        :phone='phone'
        :index='index'
        :external-errors='errors.phones'
        @change='phoneUpdate'
        @deletePhone='phoneDelete'
      )
      .form-group.form-row
        .col-sm-4.col-form-label
        .col-sm-5
          .invalid-feedback(v-for="obj in errors['phones.number']", role='alert') {{ getError(obj) }}
      .form-group.form-row
        .col-sm-4.col-form-label
        .col-sm-5
          button.add_phone(@click.prevent='addPhoneNumber') {{ $t('user.add_new_phone_number') }}
      .form-group.row
        label.col-sm-4.col-form-label.form-label
          | {{ $t('user.permissions') }}
        .form-check.form-check-inline.mr-4
          label.radio-wrapper.form-check-label(for='radioReadOnly')
            span.form-check-label-text {{ $t('user.read_only') }}
            input#radioReadOnly.form-check-input(
              type='radio'
              name='read_only'
              v-model='user.read_only'
              :value='true'
              required
            )
            span.checkmark
        .form-check.form-check-inline
          label.radio-wrapper.form-check-label(for='radioReadWrite')
            span.form-check-label-text {{ $t('user.read_and_write') }}
            input#radioReadWrite.form-check-input(
              type='radio'
              name='read_only'
              v-model='user.read_only'
              :value='false'
              required
            )
            span.checkmark

    .row.mt-3
      .col.text-right
        button.btn.btn-outline-primary.px-4.py-0.mr-3(
          @click.prevent="closeModal('modal-add-admin-user')"
        ) {{ $t('room.cancel') }}
        input.btn.btn-primary.px-4.py-0(
          type='button'
          @click.prevent='onSubmit'
          :disabled='loading'
          :value="$t('property.save_changes')"
        )
</template>
<script>
import { api } from '@/api'
import Phones from '@/pages/Admin/User/Add/phones.vue'
import { reduce, isEmpty, filter } from 'lodash'
import DatePicker from 'vue2-datepicker'
import errorMessageMixin from '@/mixins/error-message'
import addEditUserMixin from '@/mixins/add-edit-user'
import { mapState } from 'vuex'

export default {
  components: {
    DatePicker,
    Phones
  },

  mixins: [errorMessageMixin, addEditUserMixin],

  props: {
    user: {
      type: Object,
      default() {
        return {}
      }
    },

    phones: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      errors: {},
      organizations: [],
      loading: false
    }
  },

  computed: {
    ...mapState(['currentUser']),

    areAttrsNotEmpty() {
      return reduce(this.phones, (value, phone) => {
        return phone._destroy || (value && !isEmpty(phone.number))
      }, true)
    },

    isSuperadmin() {
      if (!isEmpty(this.currentUser)) {
        return this.currentUser.role == 'superadmin'
      } else {
        return false
      }
    }
  },

  mounted() {
    this.fetchOrganizations()
  },

  methods: {
    isEmpty,

    onSubmit() {
      this.loading = true

      if (this.validate()) {
        this.save()
      } else {
        this.loading = false
      }
    },

    save() {
      let user = { ...this.user, phones_attributes: this.phones }

      if (this.user.id) {
        this.editUser(user)
      } else {
        this.addUser(user)
      }
    },

    addUser(user) {
      this.makeRequestOnAddUser(user)
        .then(() => {
        this.closeModal('modal-add-admin-user')
        this.$bvToast.show('saved-notification')
        this.$emit('addedUser')
        this.loading = false
      }).catch(error => {
        this.errors = error.response.data.errors
        this.loading = false
      })
    },

    editUser(user) {
      this.makeRequestOnEditUser(user)
        .then(() => {
        this.closeModal('modal-add-admin-user')
        this.$bvToast.show('saved-notification')
        this.$emit('editedUser')
        this.loading = false
      }).catch(error => {
        this.errors = error.response.data.errors
        this.loading = false
      })
    },

    makeRequestOnAddUser(data) {
      return api.post('/users', data)
    },

    makeRequestOnEditUser(data) {
      return api.put(`/users/${this.user.id}`, data)
    },

    validate() {
      this.errors = {}

      this.validateForm()

      return isEmpty(this.errors)
    },

    validateForm() {
      const nodes = document.querySelectorAll(`#user-form :invalid`)

      if (!isEmpty(nodes)) {
        nodes.forEach(node => {
          this.errors = { ...this.errors, [node.name]: [{ error: node.validationMessage }] }
        })

        const { number, extension } = this.errors
        this.errors = { ...this.errors, phones: { number, extension } }
      }
    },

    fetchOrganizations() {
      api.get('/organizations').then(({ data: { data }}) => {
        this.organizations = filter(data, ['hide', false])
      })
    },

    closeModal(id) {
      this.$bvModal.hide(id)
    },

    phoneUpdate(object) {
      const { index, ...phone }   = object

      this.$set(this.phones, index, phone)
    },

    phoneDelete(object) {
      let deletedPhone = this.phones[object.index]
      deletedPhone._destroy = true

      this.$set(this.phones, object.index, deletedPhone)
    },

    phoneDeleted(phone) {
      return phone._destroy
    },

    addPhoneNumber() {
      if (this.areAttrsNotEmpty) {
        this.phones.push(this.defaultPhone())
      }
    },

    resetModal() {
      this.phones.map((phone) => delete phone._destroy)
      this.errors = {}
      this.loading = false
      this.$emit('reset')
    },

    allowJpOnly({ target: { name, value }}) {
      const jpValue = value.replace(/([ｧ-ﾝﾞﾟ]+)|([0-9a-bA-Z])/ig, '')
      this.user[name] = jpValue
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-primary,
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-image: linear-gradient(90deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
  border-color: transparent !important;
  border-radius: 4px;
  box-shadow: none;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 38px;
}

.btn-outline-primary,
.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active {
  background: transparent;
  border: 1px solid rgba(0, 156, 234, 0.3);
  border-radius: 4px;
  color: #009cea;
  font-size: 14px;
  height: 40px;
  line-height: 38px;
}

.modal-background {
  ::v-deep .modal-content {
    background-color: #fcfdfe !important;
  }

  ::v-deep .modal-title {
    padding-left: 15px;
  }
}

.add-user-admin {
  .form-label {
    color: #7c91a7;
    font-size: 13px;
    font-weight: 700;
  }

  .add_phone {
    background: transparent;
    border: none;
    color: #009cea;
    cursor: pointer;
  }

  .invalid-feedback {
    color: #dc3545;
    display: block;
    font-size: 65%;
    margin-top: 0.25rem;
    width: 100%;
  }

  .loader-modal {
    left: 50%;
    position: absolute;
    top: 30%;
    z-index: 1;
  }
}
</style>

